module.exports = __webpack_public_path__ + "img/daily-tournament-bg_1920.3ff43184.png";